import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogDropDownButton from "@/shared/ui/SogDropDownButton.vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import {SogDropDownButtonType} from "@/shared/ui/types/SogDropDownButtonType";

interface Props {
  mdiIcon?: string
  items?: SogDropDownButtonItem[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogCardActionDropDownButton',
  props: {
    mdiIcon: { default: "" },
    items: { default: undefined }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const _emit = __emit

function onSelect(item?: SogDropDownButtonItem) {
  _emit("select", item)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogDropDownButton, {
    "mdi-icon": __props.mdiIcon,
    type: _unref(SogDropDownButtonType).Card,
    items: __props.items,
    style: {"align-self":"flex-end"},
    onSelect: onSelect
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["mdi-icon", "type", "items"]))
}
}

})